import { useEffect } from 'react'

type GMOMultiPaymentScriptProps = Required<
  Readonly<{
    apiKey: string
  }>
>

export const GMOMultiPaymentScript = ({
  apiKey
}: GMOMultiPaymentScriptProps) => {
  useEffect(() => {
    const head = document.querySelector('head')
    if (!head) {
      return
    }
    const script = document.createElement('script')

    const url = process.env.REACT_APP_GMO_PAYMENT_TOKEN_URL
      ? process.env.REACT_APP_GMO_PAYMENT_TOKEN_URL
      : ''
    script.setAttribute('src', url)
    script.onload = () => {
      Multipayment.init(apiKey)
    }

    head.appendChild(script)

    return () => {
      // clean up the script when the component in unmounted
      head.removeChild(script)
    }
  }, [])

  return <div className='GMOMultiPaymentScript'></div>
}
